import React from 'react';

const RatingStars = ({ rating, reviews }) => {
  return (
    <div className="service-rating">
      <div className="rating-stars">
        {[...Array(5)].map((_, i) => (
          <i key={i} className={`fas fa-star ${i < Math.floor(rating) ? 'filled' : ''}`}></i>
        ))}
        <span>{rating}</span>
      </div>
      {reviews && <span className="review-count">({reviews} reviews)</span>}
    </div>
  );
};

export default RatingStars;